import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningIconSmall from 'assets/svgs/warningSmallIcon.svg';
import { AlertNotice } from 'shared/components';

const Timing = ({ timing }) => {
  const { t } = useTranslation();
  const filteredTimes = timing.filter(time => time.stopDt === null);
  return (
    <div className="timing-container">
      <h3>{t('reviewAndCloseRoom.examineeStatus.timing')}</h3>
      {filteredTimes.length ?
        <>
          <AlertNotice message={t('reviewAndCloseRoom.examineeStatus.timingWarning')} type="warning" />
          {filteredTimes.map((time, i) => <div key={`time-${i}`} className="timing-warning-list-item">
            <WarningIconSmall/>
            <div>{time.taskName}</div>
          </div>)}
        </> :
        <AlertNotice
          message={t('reviewAndCloseRoom.examineeStatus.testsRecorded')}
          type="success"
          noBorder
        />
      }
    </div>
  );
};

export default Timing;
